<template>
  <div class="content">
    <h1>Dag 3</h1>
    <h2>I dag skal I lave videre på jeres spil!</h2>
    <br />
    <p>
      I dag skal alle tegningerne til spillet skal være færdige, og spillet skal
      kodes 90% færdigt.
    </p>

    <p>
      Det første I skal gøre er, at sørge for at I kan få tegningerne hen i
      spillet. <br />
      Se hvordan herunder.
    </p>

    <h2>TIL TEGNEREN:</h2>
    <p>
      Du skal oprette en mappe på
      <a href="https://drive.google.com" target="_blank">Google Drev</a>, så du
      kan dele tegningerne med koderen. <br />
      Se hvordan, i videoen herunder.
    </p>

    <EmbedYoutube id="LRYDbYRerhY" />

    <h3>
      Hver gang du har tegnet en tegning skal du lægge den ind i mappen. <br />
      Husk at alle tegningerne skal være færdige i dag.
    </h3>

    <h2>TIL KODEREN:</h2>
    <p>
      Når din makker har delt mappen med tegninger med dig er du klar til at få
      dem ind i spillet. <br />
      Se hvordan, i videoen herunder.
    </p>

    <EmbedYoutube id="SM_Iz2poNO8" />

    <h3>
      I takt med at din makker bliver færdig med tegningerne, kan du sætte dem
      ind i spillet.
    </h3>

    <br />

    <p>
      Husk løbende at kigge på jeres to-do-liste, og snak sammen om, hvad I
      mangler at lave.
    </p>
    <br />
    <br />
    <h2>God arbejdslyst!</h2>
  </div>
</template>

<script>
import EmbedScratch from "@/components/ScratchEmbed";
export default {
  name: "Day3",
  components: {
    EmbedScratch
  }
};
</script>

<script>
import EmbedScratch from "@/components/ScratchEmbed";
import EmbedYoutube from "@/components/YoutubeEmbed";
export default {
  name: "Day3",
  components: {
    EmbedScratch,
    EmbedYoutube
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/undervisning/dag-3.vue